export default __webpack_public_path__ + "static/media/dishwasher.94f2f870.svg";